module.exports = {"title":"Same Day Delivery Order | GoGoVan Singapore","description":"Place a Same Day Delivery order with GoGoVan and get your items moving."}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/sg/setting/template_for_angular/locale.json
// module id = 722
// module chunks = 0 1 2 3 4 5